<template>
    <div class="home-btn primary"
        v-show="btnForm.status" 
        :style="btnStyle"
        @click="goLink">
        {{ $getConfigText(btnForm.buttonText) }}
    </div>
</template>

<style scoped>
.home-btn{
    width: 158px;
    line-height: 52px;
    font-size: 16px;
    border-radius: 10px;
    border: none;
    margin-top: 60px;
}
</style>

<script>
export default {
    props: {
        btnForm: Object
    },
    computed: {
        btnStyle(){
            return `background:${this.btnForm.buttonColor};` +
            `color:${this.btnForm.buttonTextColor}`
        }
    },
    methods: {
        goLink(){
            window.open(this.btnForm.buttonJumpUrl)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/blocks/block-btn.vue